import { Button } from '@ps-design-system/components/Button';
import XIcon from '@ps-design-system/icons/X/X24';
import React from 'react';
import BootstrapModal from 'shared-components/modal/bootstrap-modal';
import { CateringAddOnsForm } from './CateringAddOnsForm';

export class CateringAddOnsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      nextBtnDisabled: true
    };
  }

  componentDidUpdate(prevProps) {
    const { cateringPackage, booking, profile, showModal } = this.props;
    if (showModal && !prevProps.showModal) {
      analytics.track('catering_addons_viewed', {
        booking_id: booking?._id,
        sso_id: profile?.data?.SSOid,
        activity_tag: booking?.tags?.activity,
        catering_package_id: cateringPackage?.id
      });
    }
  }

  render() {
    const { closeModal, onNext, onBack, booking } = this.props;

    return (
      <BootstrapModal
        {...this.props}
        modalSize="lg-size"
        modalClass="catering-menu-form-modal catering-menu-addons-modal"
        fixedHeaderFooter={true}
        header={
          <div className="relative">
            <h5 className="tw-headline-4 no-margin">Add ons</h5>
            <Button
              className="absolute"
              style={{ top: '0', right: '0' }}
              iconOnly={true}
              variant="text-only"
              onClick={closeModal}
            >
              <XIcon />
            </Button>
          </div>
        }
        body={<CateringAddOnsForm numberOfGuests={booking?.number_of_guests} />}
        footer={
          <div className="catering-footer-content-wrap">
            <Button
              onClick={onBack}
              variant="underline"
              className="back-btn-hidden-mobile"
            >
              Back
            </Button>
            <Button
              onClick={onBack}
              variant="outline-1"
              appearance="white"
              className="back-btn-hidden-desktop"
            >
              Back
            </Button>
            <Button onClick={onNext}>Next</Button>
          </div>
        }
        addCloseIcon={false}
      />
    );
  }
}
